import { EModal } from 'components/site/modals/ModalWrapper/ModalContent/useGetModalProperties';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import React, { useContext, useEffect } from 'react';
import { CtxApp } from 'session/ctxApp';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    children: React.ReactNode;
    disableMessage?: boolean;
    className?: string;
}

export const MobileScrollWrapper = (props: Props): JSX.Element => {
    const ctxApp = useContext(CtxApp);
    const ctxModal = useContext(CtxModal);
    const isWide = useIsWide();

    useEffect(() => {
        if (!ctxApp.mobileMessageShown && !isWide && !props.disableMessage) {
            ctxModal.setModal({
                type: EModal.MOBILE
            });
            ctxApp.setMobileMessageShown(true);
        }
    }, []);

    return (
        <S_MobileScrollWrapper className={props.className}>{props.children}</S_MobileScrollWrapper>
    );
};

const S_MobileScrollWrapper = styled.div`
    width: 100%;
    @media only screen and (max-width: 1259px) {
        height: 100%;
        overflow-x: scroll;
    }
`;
